/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import i18n from "i18next";
import ApiButtons from "../../Buttons/Buttons/ApiButtons";
import {toast} from 'react-toastify';
import isTime2Click from "../../../utils/isTime2Click";
import {connect} from "react-redux";
import {FanpageGetHearAction, HearCreateAction, HearFanpageAttachAction} from "../../../actions";
import {HEAR_CREATE_SUCCESS} from "../../../types";

class FanpageHearsCreateForm extends Component {

    constructor(props) {
        super(props);
        this.refCreateButton = React.createRef();

        this.state = {
            code: "",
            fanpageId: null,
            codeValid: false,
            codeInvalid: false,
        };
    }

    actor() {
        return 'FanpageHearsCreateForm';
    }

    componentWillMount = async () => {
        await this.props.fanpageGetHearAction(this.props.fanpageId, this.actor(), 1, 500);//TODO: this is lazy fixed, fix this issue again: IN-345-postback-cant-choose-hear-in-other-page
        await this.props.fanpageGetHearAction(this.props.fanpageId, this.actor(), this.state.currentPage);
        // await this.checkGetStartedExist(this.props);
    };

    checkGetStartedExist = async (nextProps) => {

        let hears = nextProps.hears[this.props.fanpageId];

        if (this.isHearExist(hears)) return;

        let hearData = {
            hear: 'get_started',
            type: 'get_started',
            "replies": [
                {
                    "text": "hi",
                    "type": "text"
                }
            ]
        };

        await this.props.hearCreateAction(hearData, this.props.fanpageId, this.actor());

    };

    isHearExist(hears) {
        if (hears === undefined) return false;
        let ids = Object.keys(hears);
        return ids.length > 0;
    }

    handleCodeChange = (event) => {
        let code = event.target.value;
        this.setState({code: code});
        this.codeNameVerify(code);
    };

    handleCreateClick = () => {
        if (!isTime2Click(this.actor())) {
            return;
        }

        let isError = this.codeNameVerify(this.state.code);
        if (isError) {
            toast.error(i18n.t("Hear string invalided"));
            return;
        }

        let hearData = {
            hear: this.state.code,
            type: 'command',
            "replies": [
                {
                    "text": "hi",
                    "type": "text"
                }
            ]
        };

        this.props.hearCreateAction(hearData, this.props.fanpageId, this.actor());
        this.props.fanpageGetHearAction(this.props.fanpageId, this.actor());
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.hearCreateReducer === undefined || nextProps.hearCreateReducer.data === undefined) return;

        if (nextProps.hearCreateReducer.data.actor !== this.actor()) return;

        this.handleCreateReceive(nextProps).then();
        this.handleAttachReceive(nextProps);
    }


    handleCreateReceive = async (nextProps) => {
        if (nextProps.hearCreateReducer.data.type !== HEAR_CREATE_SUCCESS) return;

        this.setState({code: ""});

        toast.success(i18n.t("Created new Hear"));

        let hearId = nextProps.hearCreateReducer.data.data['hear_id'];
        await this.props.hearFanpageAttachAction(hearId, nextProps.fanpageId, this.actor());
        await this.props.fanpageGetHearAction(nextProps.fanpageId, this.actor());
    };

    handleAttachReceive(nextProps) {
        if (nextProps.hearCreateReducer.data.type !== HEAR_CREATE_SUCCESS) return;

        toast.success(i18n.t("Attached Hear to this Fanpage"));
        this.setState({codeValid: false, codeInvalid: false});
    }

    codeNameVerify(code) {
        let isError = false;

        let letters = /^[A-Za-z0-9_]+$/;
        let isNotMatch = !code.match(letters);

        if (isNotMatch) {
            isError = true;
        }

        if (code.length < 7 || code.length > 30) {
            isError = true;
        }

        if (isError) {
            this.setState({codeValid: false, codeInvalid: true});
        } else {
            this.setState({codeValid: true, codeInvalid: false});
        }

        return isError;
    }

    render() {
        return (
            <div style={{marginBottom: '20px'}}>
                <h5>{i18n.t('Create Hear')}</h5>
                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">{i18n.t("Hear")}</InputGroupAddon>
                        <Input
                            side={10}
                            onChange={this.handleCodeChange}
                            id={'new_hear_input'}
                            value={this.state.code}
                            invalid={this.state.codeInvalid}
                            valid={this.state.codeValid}
                        />
                    </InputGroup>
                    <small className="form-text text-muted">
                        <b className="text-danger">{i18n.t("Required.")}</b><br/>
                        {i18n.t("Hear string only allow alphabet, number and underscore [a-z,A-Z,0-9,_]")}<br/>
                        {i18n.t("Minimum 7 characters")}<br/>
                        {i18n.t("Maximum 30 characters")}<br/>
                    </small>
                </div>

                <ApiButtons
                    ref={this.refCreateButton}
                    color="primary"
                    id={'create_hear_button'}
                    text="Create"
                    onClick={(e) => this.handleCreateClick(e)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hears: state.HearsReducer,
        hearCreateReducer: state.HearCreateReducer,
    }
};

export default connect(mapStateToProps, {
    hearCreateAction: HearCreateAction,
    hearFanpageAttachAction: HearFanpageAttachAction,
    fanpageGetHearAction: FanpageGetHearAction,
})(FanpageHearsCreateForm);